import { render, staticRenderFns } from "./Reportes.vue?vue&type=template&id=1b16904c&scoped=true"
import script from "./Reportes.vue?vue&type=script&lang=js"
export * from "./Reportes.vue?vue&type=script&lang=js"
import style0 from "./Reportes.vue?vue&type=style&index=0&id=1b16904c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16904c",
  null
  
)

export default component.exports